import React, { useMemo } from 'react';
import useOrganizationMedicalProfiles from '../../../hooks/api/useOrganizationMedicalProfiles';
import { ProfileSelectionState, SelectableProfileListItem } from './types';
import { isPresent } from 'ts-is-present';
import urls from '../../../utils/urls';

export type ProAppProfilesProviderOwnProps = {
    medicalProfileIds: string[];
    children: (ProfileSelectionState: ProfileSelectionState) => React.ReactNode;
};

export type ProAppProfilesProviderProps = ProAppProfilesProviderOwnProps;

const ProAppProfilesProvider: React.FC<ProAppProfilesProviderProps> = (props) => {
    const { isLoadingOrganizationMedicalProfiles, organizationMedicalProfiles } = useOrganizationMedicalProfiles();

    const profiles = useMemo<SelectableProfileListItem[]>(() => {
        return props.medicalProfileIds
            .map((medicalProfileId) => {
                const profile = organizationMedicalProfiles.find((_) => _.medicalProfileId === medicalProfileId);
                if (!profile) {
                    return null;
                }

                return {
                    ...profile,
                    avatarUrl: urls.api.medicalProfiles.avatar(profile.medicalProfileId),
                };
            })
            .filter(isPresent);
    }, [organizationMedicalProfiles, props.medicalProfileIds]);

    return props.children({
        profiles,
        isLoadingProfiles: isLoadingOrganizationMedicalProfiles,
        selectedProfileIds: props.medicalProfileIds,
        onToggleProfileId: () => {},
        onSetProfileIds: () => {},
    });
};

export default React.memo(ProAppProfilesProvider);
